<template>
  <div class="store_list_page">
    <van-cell-group>
      <template v-if="isMustLoaction">
        <van-cell
          v-for="item in storeList"
          :key="item.id"
          :title="item.name"
          :label="item.address"
          :value="item.juli"
          center
        >
        </van-cell>
      </template>
      <template v-else>
        <van-cell
          v-for="item in storeList"
          :key="item.id"
          :title="item.name"
          :label="item.address"
          center
        >
        </van-cell>
      </template>
    </van-cell-group>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { getStoreList } from "jhm_api_ts";
import JhmMap from "jhm_map";
import { hiddenLoading, showLoading } from "@/utils/loading";

@Component({})
export default class StoreList extends Vue {
  gid = (this.$route.query.gid || "") + "";
  storeList = [];
  // 是否需要定位
  isMustLoaction = false;

  async mounted() {
    showLoading();
    let { info } = await getStoreList({
      id: this.gid,
      ...(await this.getPosition()),
    });
    hiddenLoading();
    this.storeList = info;
  }

  async getPosition() {
    if (this.isMustLoaction) {
      try {
        await JhmMap.config();
        let position = await JhmMap.getCurrentPosition();
        return {
          lat: position.lat,
          lng: position.lng,
        };
      } catch (e) {
        this.$toast.fail(e);
        return {};
      }
    } else {
      return {};
    }
  }
}
</script>

<style lang="scss" scoped>
.store_list_page {
  .city_wrap {
    display: flex;
    justify-content: space-between;

    padding: 10px 17px;

    font-size: 15px;

    span:nth-child(1) {
      color: rgb(228, 47, 70);
    }
    span:nth-child(2) {
      color: rgb(153, 153, 153);
    }
  }

  .van-cell {
    span {
      font-size: 15px;
      line-height: 15px;
      color: #333333;
    }
    .van-cell__label {
      font-size: 12px;
      line-height: 1.2;
      color: #999999;
    }
  }
}
</style>
